















































































































































































import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
@Component
export default class JobDetail extends mixins(DictMixin) {
  @Prop() detail!: any;
  @Prop() logs!: any;
}
